import React, { createContext, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { NotFound } from '@js/components/errors/NotFound';
import { ScrollToTop } from '@js/components/common/ScrollToTop';
import { routes, snsAuthRoutes } from './routes';
type ContextType = {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isEdit: boolean;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  isSubmitting: boolean;
  setIsSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
  shouldSkipCompatibility: boolean;
  setShouldSkipCompatibility: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialState: ContextType = {
  isLoading: false,
  setIsLoading: () => undefined,
  isEdit: false,
  setIsEdit: () => undefined,
  isSubmitting: false,
  setIsSubmitting: () => undefined,
  shouldSkipCompatibility: false,
  setShouldSkipCompatibility: () => undefined,
};

export const Context = createContext(initialState);

export const RegistrationRouter = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [shouldSkipCompatibility, setShouldSkipCompatibility] = useState<boolean>(false);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Context.Provider value={{ isLoading, setIsLoading, isEdit, setIsEdit, isSubmitting, setIsSubmitting, shouldSkipCompatibility, setShouldSkipCompatibility }}>
        <Switch>
          <Route
            path="/corporate_registration"
            render={({ match: { url } }) => (
              <Switch>
                {routes.map((route) => {
                  return (
                    <Route
                      exact={route.exact}
                      path={url + route.path}
                      key={route.path}
                    >
                      {route.children}
                    </Route>
                  );
                })}
              </Switch>
            )}
          />
          <Route
            path="/login"
            render={({ match: { url } }) => (
              <Switch>
                {snsAuthRoutes.map(route => {
                  return (
                    <Route
                      exact={route.exact}
                      path={url + route.path}
                      key={route.path}
                    >
                      {route.children}
                    </Route>
                  );
                }
                )}
              </Switch>
            )}
          />
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </Context.Provider>
    </BrowserRouter>
  );
};

export const LoginRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <Route
          path="/login"
          render={({ match: { url } }) => (
            <Switch>
              {snsAuthRoutes.map((route) => {
                return (
                  <Route
                    exact={route.exact}
                    path={url}
                    key={route.path}
                  >
                    {route.children}
                  </Route>
                );
              })}
            </Switch>
          )}
        />
        <Route
          path="/customers/new"
          render={({ match: { url } }) => (
            <Switch>
              {snsAuthRoutes.map((route) => {
                return (
                  <Route
                    exact={route.exact}
                    path={url}
                    key={route.path}
                  >
                    {route.children}
                  </Route>
                );
              })}
            </Switch>
          )}
        />
      </Switch>
    </BrowserRouter>
  );
};
